var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},_vm._l((_vm.sources),function(s,index){return _c('div',{key:index,class:['slider--item', { selected: index === _vm.landingIndex }]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }